import { useQuery } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const getArchiveIndexSetCOverview = async () => ArchiveArchiveIndexSet.indexSetOverview();
export const ARCHIVE_INDEX_SET_OVERVIEW_QUERY_KEY = "archive_index_set_overview";
const refetchInterval = 5e3;
const useArchiveIndexSetOverview = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [ARCHIVE_INDEX_SET_OVERVIEW_QUERY_KEY],
    queryFn: () => defaultOnError(
      getArchiveIndexSetCOverview(),
      `Loading Archive Index Set Overview failed with status`,
      `Could not load Archive Index Set Overview`
    ),
    refetchInterval,
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useArchiveIndexSetOverview;
